import StoreSettingsPage from './detail/StoreSettingsPage';
import PaymentMethodsTab from './detail/PaymentMethodsTab';

export default function StorePaymentMethods() {
	return (
		<StoreSettingsPage title='Store - Payment Methods'>
			{(store) => <PaymentMethodsTab storeId={store.storeId} />}
		</StoreSettingsPage>
	);
}
